var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 13.5V8.5C35 7.39543 34.1046 6.5 33 6.5H27",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5V27.5C35 28.6046 34.1046 29.5 33 29.5H5C3.89543 29.5 3 28.6046 3 27.5V8.5C3 7.39543 3.89543 6.5 5 6.5H10",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 29.5V33.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.5V33.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33.5C17 35 16 36 15 36.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33.5C21 35 22 36 23 36.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 36.5H26",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 26.5H35",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9375 3.5H11.0625C10.4757 3.5 10 3.97259 10 4.55556V21.4444C10 22.0274 10.4757 22.5 11.0625 22.5H25.9375C26.5243 22.5 27 22.0274 27 21.4444V4.55556C27 3.97259 26.5243 3.5 25.9375 3.5Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3467 7.5H24.4268",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3467 10.5H24.4268",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5H24.9824",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H24.9824",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0088 19.7031H24.9912",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1055 6.42188H12.457C12.2737 6.42188 12.125 6.57053 12.125 6.75391V11.4023C12.125 11.5857 12.2737 11.7344 12.457 11.7344H17.1055C17.2888 11.7344 17.4375 11.5857 17.4375 11.4023V6.75391C17.4375 6.57053 17.2888 6.42188 17.1055 6.42188Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7332 18.9338L29 21.5L31.5662 20.7668L37.5784 14.7546C38.0916 14.2413 38.0916 13.3982 37.5784 12.8849C37.0652 12.3717 36.222 12.3717 35.7088 12.8849L29.7332 18.9338Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0856 13.5081L36.9186 15.3411",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/Marketing.5a216c010d235719fddaf997f0fd3ab5.svg";
export { ForwardRef as ReactComponent };